import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import CourtDeadlineRule from '../../entities/courtDeadlineRule';

/*
 * Delete/nullify anywhere this courtDeadlineRule is used in other entities
 *
 * @param {CourtDeadlineRule} courtDeadlineRule
 */
export function deleteCourtDeadlineRule(courtDeadlineRule: CourtDeadlineRule, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = courtDeadlineRule.id;
    }

    /* Remove the actual courtDeadlineRule */
    courtDeadlineRule.status = 'D';
    courtDeadlineRule.addedOn = newHRTimestamp();
    courtDeadlineRule.addedBy = getCurrentUserId();
    courtDeadlineRule.importSource = targetImportSource;
    courtDeadlineRule.importId = mergeId;
    store.dispatch(Actions.CourtDeadlineRuleActions.removeCourtDeadlineRuleQueue(courtDeadlineRule));
    
}